import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { WorldMap, LevelNode } from "../../models/problem.models";
import { ProblemService } from "../../services/problem.service";

@Component({
  selector: "app-level-map",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./level-map.component.html",
  styleUrl: "./level-map.component.css"
})
export class LevelMapComponent implements OnInit {
  worlds: WorldMap[] = [];
  loading = true;
  error = "";

  constructor(
    private readonly problemService: ProblemService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.problemService.getWorldMap().subscribe({
      next: (worlds) => {
        this.worlds = worlds;
        this.loading = false;
      },
      error: (error) => {
        this.error = error?.error?.message || "Failed to load level map";
        this.loading = false;
      }
    });
  }

  openLevel(level: LevelNode) {
    if (level.status === "LOCKED") {
      return;
    }
    this.router.navigate(["/challenge", level.id]);
  }

  trackByWorld(_: number, world: WorldMap) {
    return world.worldNumber;
  }

  trackByLevel(_: number, level: LevelNode) {
    return level.id;
  }
}
